export const SHOW_MEAN_ON_MEASUREMENT_GRAPH = false;
export const SHOW_MEDIAN_ON_MEASUREMENT_GRAPH = true;
